import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ endsAt, testid }) => {
  const [left, setLeft] = useState(() => Math.max(0, new Date(endsAt).getTime() - Date.now()));

  useEffect(() => {
    const t = setInterval(() => {
      setLeft(Math.max(0, new Date(endsAt).getTime() - Date.now()));
    }, 1000);
    return () => clearInterval(t);
  }, [endsAt]);

  const d = Math.floor(left / 86400000);
  const h = Math.floor((left % 86400000) / 3600000);
  const m = Math.floor((left % 3600000) / 60000);
  const s = Math.floor((left % 60000) / 1000);

  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 font-mono text-xs text-emerald-300">
      <Clock className="h-3.5 w-3.5" />
      {d > 0 && <span>{d}d</span>}
      <span>{pad(h)}:{pad(m)}:{pad(s)}</span>
    </span>
  );
};

export default Countdown;
